import { TAB_ITEMS, HeaderPage } from '../constants/header.constants'

interface HeaderTabsProps {
  onChange: (page: HeaderPage) => void
  className?: string
}

export const HeaderTabs = ({ onChange, className }: HeaderTabsProps) => {
  return (
    <div className={`uppercase-s w-[585px] flex justify-between text-14 ${className}`}>
      {TAB_ITEMS.map((tab: HeaderPage) => (
        <span key={tab} className="w-full text-center cursor-pointer" onClick={() => onChange(tab)}>
          {tab.toUpperCase()}
        </span>
      ))}
    </div>
  )
}
